var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__grid"},[_c('div',{staticClass:"container__grid__main"},[_c('router-view')],1),_c('div',{staticClass:"container__grid__menu"},[_c('Menu')],1),_c('div',{staticClass:"container__grid__footer"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }